/**
 * Frontend UI HTML and Identifier Utilities.
 *
 * Provides safe HTML entity escaping and basket leg ID generation.
 */

/**
 * Escapes characters with special meaning in HTML (&, <, >, ", ').
 */
export function escapeHtml(str: unknown): string {
  if (str == null) return "";
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

/**
 * Generates unique basket leg IDs in the format `bl_<timestamp>_<rand>`.
 */
export function generateBasketLegId(
  now: number = Date.now(),
  rand?: string,
): string {
  const suffix = rand || Math.random().toString(36).slice(2, 6);
  return `bl_${now}_${suffix}`;
}
